import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList } from "@/mixins/index";
import addserversList from "./addserversList";
export default {
  props: ['eventId'],
  mixins: [loadMoreList],
  components: {
    addserversList: addserversList
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      tableData: [],
      listId: '',
      paramsData: {
        page: 1
      },
      reqLoading: false
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.listId = data.id;
                }

                _context.next = 3;
                return _this.getList(1);

              case 3:
                _this.dialogFormVisible = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getList: function getList(page) {
      var _this2 = this;

      this.paramsData.page = page;
      this.$api.getDelayedTasks({
        id: this.listId
      }).then(function (res) {
        if (res.code == 0) {
          var data = res.data;
          _this2.tableData = data;
        }
      });
    },
    getServerData: function getServerData(row) {
      var _this3 = this;

      this.$api.getDelayedTaskDetail({
        id: this.listId,
        timestamp: row.timestamp
      }).then(function (res) {
        if (res.code == 0) {
          if (res.data.extend.length == 0) {
            res.data.extend = '{}';
          } else {
            res.data.extend = JSON.stringify(res.data.extend);
          }

          res.data.delay_time = row.execute_time;

          _this3.$refs.addserversList.init(res.data, '1');
        }
      });
    }
  }
};